import {
  ArchiveBoxIcon as ArchiveBoxOutlineIcon,
  BanknotesIcon as BanknotesOutlineIcon,
  BellIcon as BellOutlineIcon,
  BoltIcon as BoltOutlineIcon,
  BookOpenIcon as BookOpenOutlineIcon,
  BriefcaseIcon as BriefcaseOutlineIcon,
  BuildingOffice2Icon as BuildingOffice2OutlineIcon,
  BuildingStorefrontIcon as BuildingStorefrontOutlineIcon,
  CalculatorIcon as CalculatorOutlineIcon,
  CalendarIcon as CalendarOutlineIcon,
  CameraIcon as CameraOutlineIcon,
  ChartBarIcon as ChartBarOutlineIcon,
  ChatBubbleLeftRightIcon as ChatBubbleLeftRightOutlineIcon,
  ChatBubbleOvalLeftIcon as ChatBubbleOvalLeftOutlineIcon,
  ClipboardDocumentListIcon as ClipboardDocumentListOutlineIcon,
  ClockIcon as ClockOutlineIcon,
  CloudIcon as CloudOutlineIcon,
  CogIcon as CogOutlineIcon,
  CreditCardIcon as CreditCardOutlineIcon,
  CubeIcon as CubeOutlineIcon,
  CurrencyYenIcon as CurrencyYenOutlineIcon,
  DocumentDuplicateIcon as DocumentDuplicateOutlineIcon,
  DocumentTextIcon as DocumentTextOutlineIcon,
  EnvelopeIcon as EnvelopeOutlineIcon,
  FaceSmileIcon as FaceSmileOutlineIcon,
  FilmIcon as FilmOutlineIcon,
  FireIcon as FireOutlineIcon,
  FlagIcon as FlagOutlineIcon,
  FolderIcon as FolderOutlineIcon,
  GiftIcon as GiftOutlineIcon,
  GlobeAltIcon as GlobeAltOutlineIcon,
  HeartIcon as HeartOutlineIcon,
  HomeIcon as HomeOutlineIcon,
  InboxIcon as InboxOutlineIcon,
  KeyIcon as KeyOutlineIcon,
  LightBulbIcon as LightBulbOutlineIcon,
  LinkIcon as LinkOutlineIcon,
  MapIcon as MapOutlineIcon,
  MapPinIcon as MapPinOutlineIcon,
  MegaphoneIcon as MegaphoneOutlineIcon,
  NewspaperIcon as NewspaperOutlineIcon,
  PaperAirplaneIcon as PaperAirplaneOutlineIcon,
  PhoneIcon as PhoneOutlineIcon,
  PhotoIcon as PhotoOutlineIcon,
  PresentationChartLineIcon as PresentationChartLineOutlineIcon,
  PrinterIcon as PrinterOutlineIcon,
  QrCodeIcon as QrCodeOutlineIcon,
  QuestionMarkCircleIcon as QuestionMarkCircleOutlineIcon,
  ReceiptPercentIcon as ReceiptPercentOutlineIcon,
  RocketLaunchIcon as RocketLaunchOutlineIcon,
  ScaleIcon as ScaleOutlineIcon,
  ShieldCheckIcon as ShieldCheckOutlineIcon,
  ShoppingCartIcon as ShoppingCartOutlineIcon,
  SparklesIcon as SparklesOutlineIcon,
  StarIcon as StarOutlineIcon,
  TagIcon as TagOutlineIcon,
  TrophyIcon as TrophyOutlineIcon,
  TruckIcon as TruckOutlineIcon,
  UsersIcon as UsersOutlineIcon,
  VideoCameraIcon as VideoCameraOutlineIcon,
  WalletIcon as WalletOutlineIcon,
  WrenchIcon as WrenchOutlineIcon,
} from '@heroicons/react/24/outline';
import {
  ArchiveBoxIcon,
  BanknotesIcon,
  BellIcon,
  BoltIcon,
  BookOpenIcon,
  BriefcaseIcon,
  BuildingOffice2Icon,
  BuildingStorefrontIcon,
  CalculatorIcon,
  CalendarIcon,
  CameraIcon,
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  ChatBubbleOvalLeftIcon,
  ClipboardDocumentListIcon,
  ClockIcon,
  CloudIcon,
  CogIcon,
  CreditCardIcon,
  CubeIcon,
  CurrencyYenIcon,
  DocumentDuplicateIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  FaceSmileIcon,
  FilmIcon,
  FireIcon,
  FlagIcon,
  FolderIcon,
  GiftIcon,
  GlobeAltIcon,
  HeartIcon,
  HomeIcon,
  InboxIcon,
  KeyIcon,
  LightBulbIcon,
  LinkIcon,
  MapIcon,
  MapPinIcon,
  MegaphoneIcon,
  NewspaperIcon,
  PaperAirplaneIcon,
  PhoneIcon,
  PhotoIcon,
  PresentationChartLineIcon,
  PrinterIcon,
  QrCodeIcon,
  QuestionMarkCircleIcon,
  ReceiptPercentIcon,
  RocketLaunchIcon,
  ScaleIcon,
  ShieldCheckIcon,
  ShoppingCartIcon,
  SparklesIcon,
  StarIcon,
  TagIcon,
  TrophyIcon,
  TruckIcon,
  UsersIcon,
  VideoCameraIcon,
  WalletIcon,
  WrenchIcon,
} from '@heroicons/react/24/solid';
import clsx from 'clsx';
import type { ComponentType, SVGProps } from 'react';
import { HeaderMenuIconVariantEnum } from '@/api/hanly/hanlyAPI.schemas';
import type { HeaderMenuIconValue } from './header-menu-types';

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

// 塗り/線ともに Heroicons を使い、同じアイコン名で引けるようにする
const solidIcons = {
  TruckIcon,
  PhoneIcon,
  CalendarIcon,
  BookOpenIcon,
  BuildingStorefrontIcon,
  EnvelopeIcon,
  DocumentTextIcon,
  GlobeAltIcon,
  ChatBubbleOvalLeftIcon,
  ReceiptPercentIcon,
  ArchiveBoxIcon,
  ChartBarIcon,
  CalculatorIcon,
  ClipboardDocumentListIcon,
  UsersIcon,
  StarIcon,
  BellIcon,
  WrenchIcon,
  WalletIcon,
  BanknotesIcon,
  VideoCameraIcon,
  MapIcon,
  QuestionMarkCircleIcon,
  HomeIcon,
  LinkIcon,
  ShoppingCartIcon,
  BuildingOffice2Icon,
  NewspaperIcon,
  FolderIcon,
  TagIcon,
  BriefcaseIcon,
  CameraIcon,
  ChatBubbleLeftRightIcon,
  ClockIcon,
  CloudIcon,
  CogIcon,
  CreditCardIcon,
  CubeIcon,
  CurrencyYenIcon,
  DocumentDuplicateIcon,
  FaceSmileIcon,
  FilmIcon,
  FireIcon,
  FlagIcon,
  GiftIcon,
  HeartIcon,
  InboxIcon,
  KeyIcon,
  LightBulbIcon,
  MegaphoneIcon,
  PaperAirplaneIcon,
  PhotoIcon,
  PresentationChartLineIcon,
  PrinterIcon,
  QrCodeIcon,
  RocketLaunchIcon,
  ScaleIcon,
  ShieldCheckIcon,
  SparklesIcon,
  TrophyIcon,
  MapPinIcon,
  BoltIcon,
} satisfies Record<string, IconComponent>;

type HeaderMenuIconName = keyof typeof solidIcons;

const outlineIcons: Record<HeaderMenuIconName, IconComponent> = {
  TruckIcon: TruckOutlineIcon,
  PhoneIcon: PhoneOutlineIcon,
  CalendarIcon: CalendarOutlineIcon,
  BookOpenIcon: BookOpenOutlineIcon,
  BuildingStorefrontIcon: BuildingStorefrontOutlineIcon,
  EnvelopeIcon: EnvelopeOutlineIcon,
  DocumentTextIcon: DocumentTextOutlineIcon,
  GlobeAltIcon: GlobeAltOutlineIcon,
  ChatBubbleOvalLeftIcon: ChatBubbleOvalLeftOutlineIcon,
  ReceiptPercentIcon: ReceiptPercentOutlineIcon,
  ArchiveBoxIcon: ArchiveBoxOutlineIcon,
  ChartBarIcon: ChartBarOutlineIcon,
  CalculatorIcon: CalculatorOutlineIcon,
  ClipboardDocumentListIcon: ClipboardDocumentListOutlineIcon,
  UsersIcon: UsersOutlineIcon,
  StarIcon: StarOutlineIcon,
  BellIcon: BellOutlineIcon,
  WrenchIcon: WrenchOutlineIcon,
  WalletIcon: WalletOutlineIcon,
  BanknotesIcon: BanknotesOutlineIcon,
  VideoCameraIcon: VideoCameraOutlineIcon,
  MapIcon: MapOutlineIcon,
  QuestionMarkCircleIcon: QuestionMarkCircleOutlineIcon,
  HomeIcon: HomeOutlineIcon,
  LinkIcon: LinkOutlineIcon,
  ShoppingCartIcon: ShoppingCartOutlineIcon,
  BuildingOffice2Icon: BuildingOffice2OutlineIcon,
  NewspaperIcon: NewspaperOutlineIcon,
  FolderIcon: FolderOutlineIcon,
  TagIcon: TagOutlineIcon,
  BriefcaseIcon: BriefcaseOutlineIcon,
  CameraIcon: CameraOutlineIcon,
  ChatBubbleLeftRightIcon: ChatBubbleLeftRightOutlineIcon,
  ClockIcon: ClockOutlineIcon,
  CloudIcon: CloudOutlineIcon,
  CogIcon: CogOutlineIcon,
  CreditCardIcon: CreditCardOutlineIcon,
  CubeIcon: CubeOutlineIcon,
  CurrencyYenIcon: CurrencyYenOutlineIcon,
  DocumentDuplicateIcon: DocumentDuplicateOutlineIcon,
  FaceSmileIcon: FaceSmileOutlineIcon,
  FilmIcon: FilmOutlineIcon,
  FireIcon: FireOutlineIcon,
  FlagIcon: FlagOutlineIcon,
  GiftIcon: GiftOutlineIcon,
  HeartIcon: HeartOutlineIcon,
  InboxIcon: InboxOutlineIcon,
  KeyIcon: KeyOutlineIcon,
  LightBulbIcon: LightBulbOutlineIcon,
  MegaphoneIcon: MegaphoneOutlineIcon,
  PaperAirplaneIcon: PaperAirplaneOutlineIcon,
  PhotoIcon: PhotoOutlineIcon,
  PresentationChartLineIcon: PresentationChartLineOutlineIcon,
  PrinterIcon: PrinterOutlineIcon,
  QrCodeIcon: QrCodeOutlineIcon,
  RocketLaunchIcon: RocketLaunchOutlineIcon,
  ScaleIcon: ScaleOutlineIcon,
  ShieldCheckIcon: ShieldCheckOutlineIcon,
  SparklesIcon: SparklesOutlineIcon,
  TrophyIcon: TrophyOutlineIcon,
  MapPinIcon: MapPinOutlineIcon,
  BoltIcon: BoltOutlineIcon,
};

export const headerMenuIconNames = Object.keys(solidIcons) as HeaderMenuIconName[];

// icon_name はAPIで任意の文字列を保存できるため、__proto__ などの継承プロパティを引かないよう Map で引く
const headerMenuIconCatalog: Record<HeaderMenuIconVariantEnum, Map<string, IconComponent>> = {
  [HeaderMenuIconVariantEnum.SOLID]: new Map(Object.entries(solidIcons)),
  [HeaderMenuIconVariantEnum.OUTLINE]: new Map(Object.entries(outlineIcons)),
};

export const headerMenuIconVariantTabs: Record<
  HeaderMenuIconVariantEnum,
  { label: string; icon: IconComponent }
> = {
  [HeaderMenuIconVariantEnum.SOLID]: { label: '塗り', icon: StarIcon },
  [HeaderMenuIconVariantEnum.OUTLINE]: { label: '線', icon: StarOutlineIcon },
};

interface HeaderMenuIconProps {
  icon: HeaderMenuIconValue;
  className?: string;
}

export const HeaderMenuIcon = ({ icon, className }: HeaderMenuIconProps) => {
  // 候補から外れたアイコン名はリンクアイコンで表示する
  const Icon = headerMenuIconCatalog[icon.variant]?.get(icon.name) ?? LinkIcon;
  return <Icon className={clsx('w-6 h-6', className)} />;
};
